// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReasonUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ReasonUtils.bs.js";
import * as AssetsManager$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/assets/AssetsManager.bs.js";

var warningSymbol = AssetsManager$Catalyst.getImage("warning.svg");

function ErrorFileSection(Props) {
  var fileName = Props.fileName;
  var csvFileContent = Props.csvFileContent;
  var className = Props.className;
  return React.createElement("div", {
              className: className
            }, React.createElement("div", {
                  className: "header u-flex__row"
                }, React.createElement("img", {
                      className: "warningSymbol",
                      src: warningSymbol
                    }), React.createElement("p", {
                      className: "title"
                    }, "Error in the file")), React.createElement("div", {
                  className: "content"
                }, React.createElement("div", {
                      className: "rectifyErrorMessage"
                    }, "Download", ReasonUtils$Catalyst.nbsp, React.createElement("span", {
                          className: "fileName"
                        }, fileName), "> Rectify the error > Upload again"), React.createElement("div", {
                      className: "fileDownloadLinkSection"
                    }, React.createElement("a", {
                          className: "link",
                          download: fileName,
                          href: csvFileContent
                        }, fileName))));
}

var make = ErrorFileSection;

export {
  warningSymbol ,
  make ,
  
}
/* warningSymbol Not a pure module */
